<template>
  <div class="subject-dist text-dark">
    <SubjectDistributionPrint
      v-if="isPrintUsers"
      @close="closeIsPrintUsers">
    </SubjectDistributionPrint>
    <template v-else="isPrintUsers">
      <div class="subject-dist__header">
        <div class="subject-dist__header__left">
          <h1>{{ i18n[locale].subjects_for_teachers }}</h1>
          <ChangeSchoolYear :whiteTheme="true"></ChangeSchoolYear>
        </div>
        <div class="subject-dist__header__right">
          <a v-if="theZENToken.length > 0" :href="zenUrl" target="_blank">{{ i18n[locale].go_to_zen }}</a>
          <button class="do-bttn bttn-export" @click="isOpenDurationModal = true"
                  v-if="userCanManageSchool">
            {{ i18n[locale].export_to_zen }}
          </button>
          <div class="flipper-buttons">
            <button @click="isTasksView = false" class="flipper-buttons__button"
                    :class="{'active': !isTasksView}">
              <span class="icon-year-planning"></span>
              {{ i18n[locale].subjects }}
            </button>
            <button @click="isTasksView = true" class="flipper-buttons__button"
                    :class="{'active': isTasksView}">
              <span class="icon-file-text"></span>
              {{ i18n[locale].tasks }}
            </button>
          </div>
        </div>
      </div>
      <Loader v-if="isLoading" color="blue"></Loader>
      <div class="subject-dist__body" v-else>
        <div class="doTable__users">
          <div class="doTable__users__header">
            <FilterUsers class="pad-10" :searchText="i18n[locale].filter_users"></FilterUsers>
          </div>
          <div class="filter pointer" v-if="!isPoolsDeactivated">
            <input type="checkbox" v-model="isShowOnlyTeacherWithTeachingTime"
                   id="only-teachers-with-teaching_time">
            <label class="marg-5-left pointer no-select" for="only-teachers-with-teaching_time">
              {{ i18n[locale].only_show_users_with_uv_time }}
            </label>
          </div>
          <ul class="d-box users-list">
            <li class="user-item user-item__header">
              <div class="user-sorter" :class="{'user-sorter--active': sortBy === 'name'}"
                   @click="setSortBy('name')">{{ i18n[locale].name }}
                <span class="icon-menu-open"></span></div>
              <div class="user-sorter" :class="{'user-sorter--active': sortBy === 'teachingTimeDiff'}"
                   @click="setSortBy('teachingTimeDiff')">{{ i18n[locale].teaching_hours }} <span
                class="icon-menu-open"></span></div>
            </li>
            <h4 class="explainer-text" v-if="sortedUsersFilteredWithTags.length < 1">
              {{ i18n[locale].no_users_matches }}
            </h4>
            <li class="user-item"
                v-for="user in sortedUsersFilteredWithTags"
                @click="setActiveUserId(user.id)"
                :key="user.user_calendar_id"
                :class="{'user-item--is-open': user.id === activeUserId}">
              <div class="user-item__name" v-if="user.id !== activeUserId"><span class="icon-arrow-right4"></span>
                <img class="user-item__name__img" v-if="user.default_thumb_url" :src="user.default_thumb_url">
                <p>{{ user.name }}</p>
              </div>
              <div v-if="user.id !== activeUserId">
                <span class="icon-file-text2" v-if="userHasAgreements(user.id)"></span>
                {{ getUserTeachingHoursDiff(user.id) }}
                <span class="icon-arrow-down4"></span>
              </div>
              <SubjectsDistributionUser
                v-if="user.id === activeUserId"
                :activeUserId="activeUserId"
                :isPoolsDeactivated="isPoolsDeactivated"
                @editSubject="setEditSubject"
                @editTask="setEditTask"
                @close="resetActiveUserId">
              </SubjectsDistributionUser>
            </li>
          </ul>
        </div>
        <div class="subjects-and-tasks">
          <SubjectsDistributionTasks v-if="isTasksView"></SubjectsDistributionTasks>
          <div class="doTable" v-else>
            <div class="subject-dist__header">
              <div class="subject-dist__header__left">
                <DoFiltersFilter
                  :title="i18n[locale]['grades']"
                  :tags="klassTags"
                  :selectedTags="selectedKlassFilters"
                  @select="toggleKlassTag"
                  @clear="clearSelectedKlassFilters"
                >
                </DoFiltersFilter>
                <DoFiltersFilter
                  :title="i18n[locale]['subjects_status']"
                  :tags="subjectStatusFilters"
                  :selectedTags="selectedSubjectStatusFilters"
                  @select="toggleSelectedSubjectStatusFilters"
                  @clear="clearSelectedSubjectStatusFilters"
                >
                </DoFiltersFilter>
                <DoFiltersFilter
                  :title="i18n[locale]['subjects']"
                  :tags="uniqueSubjects"
                  :selectedTags="selectedSubjectFilters"
                  @select="toggleSelectedSubjectFilters"
                  @clear="clearSelectedSubjectFilters"
                >
                </DoFiltersFilter>
              </div>
              <div class="subject-dist__header__right">
                <div class="do-spinner do-spinner--small" v-if="isUpdatingSchoolYear"></div>
                <DoButtonAndDate
                  content="Fag kan ønskes af brugere med rettigheden"
                  v-tippy="{
                    arrow: false,
                    placement : 'top'
                  }"
                  v-if="userCanManageSchool && isSchoolDanish"
                  :selectedDate="subjectsRequestEndDate"
                  @dateChanged="onSetSubjectsRequestEndDate">
                </DoButtonAndDate>
              </div>
            </div>
            <ul class=" doTable__items
              ">
              <li class="doTable__klass"
                  v-for="(klassCal, idx) in filteredKlassCals"
                  :key="klassCal.id">
                <div class="doTable__klass__header">
                  <div>{{ klassCal.name }}</div>
                  <div class="doTable__klass__header__flex">
                    <div class="icon__bg-circle"
                         v-if="isSchoolDanish && idx === 0"
                         @click="isModalKlassTotalHours = true"
                         content="Ændre fag der tæller i med i Timer i skoleåret"
                         v-tippy="{
                           arrow: true,
                           animateFill: false,
                           animation : 'shift-away',
                           zIndex: '999999992',
                           boundary: 'window'}">
                      <span class="icon-wrench"></span>
                    </div>
                    <label>{{ i18n[locale].hours_in_school_year }}:</label>
                    <span class="doTable__klass__header__hours">{{ klassCal.vTotalHours }}</span>
                  </div>
                </div>
                <ul class="subjects">
                  <li class="subjects_subject"
                      v-for="subject in klassCal.vSubjects"
                      :key="subject.id"
                      @click="setEditSubject(subject)"
                      :class="[{'subject--has-user': subject.vHasTeachers}, {'subject--has-room': subject.vHasRooms}, {'subject--has-request': subject.vRequestedBy.length > 0}]"
                      :style="{'background': subject.color}"
                      :content="subject.vUserNames"
                      v-tippy="{
                    arrow: true,
                    onShow: () => subject.vHasTeachers
                  }">
                    {{ subject.name }} ({{ subject.vHours }})
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <SubjectForm
      v-if="isSubjectModal"
      :showModal="isSubjectModal"
      :editSubject="editSubject"
      :propIsLoading="isSubjectLoading"
      :isShowSubjectsRequest="isShowSubjectsRequest"
      :subjectsRequestsInHash="subjectsRequestsInHash"
      @deleteSubject="deleteSubject"
      @close="closeModal"
      @updateSubject="updateSubject">
    </SubjectForm>
    <transition name="d-modal">
      <ModalConfirmation
        v-if="isConfirmDeletion"
        :showClose="false"
        @close="$store.commit('setConfirmDeletion', false)"
        @confirm="confirmDelete">
        <h3 slot="item">{{ itemToDelete.name }}</h3>
      </ModalConfirmation>
    </transition>
    <transition name="d-modal">
      <DModal v-if="theEditTask" :showClose="false">
        <SubjectsDistributionTasksCreate
          slot="insertComponent"
          :editTask="theEditTask"
          @close="theEditTask = null">
        </SubjectsDistributionTasksCreate>
      </DModal>
    </transition>
    <StandardDurationSetting
      :isForImportInZEN="true"
      :isOpenModal="isOpenDurationModal"
      @close="isOpenDurationModal = false"
      @submit="saveUpdatedDuration">
    </StandardDurationSetting>
    <DModal :isBgOverlay="true" :show-close="false" v-if="isModalKlassTotalHours">
      <div class="d-modal text-dark" slot="insertComponent">
        <div class="d-modal__header">
          <h4>Ændre "Timer i skoleåret"</h4>
          <div class="icon__bg-circle" @click="isModalKlassTotalHours = false">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__content">
          <div class="label-with-toggle" @click="toggleDoesRessCount">
            <label class="d-label">Skal ressourcetimer tælle med i tallet "Timer i skoleåret" på denne side?</label>
            <app-toggle :allowChanges="false" :propOn="doesRessCountInKlassTotalHours"></app-toggle>
          </div>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import SubjectForm from '../Subjects/SubjectForm'
import FilterUsers from '../Tagging/FilterUsers'
import TaggingFilter from '../Tagging/TaggingFilter'
import Spinner from '../common/Spinner'
import SubjectsDistributionTasks from './SubjectsDistributionTasks'
import AppFlipperButton from '../common/AppFlipperButtons'
import SubjectsDistributionUser from './SubjectsDistributionUser'
import ModalConfirmation from '../Modals/ModalConfirmation'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import SubjectDistributionPrint from './SubjectsDistributionPrint'
import SubjectsDistributionTasksCreate from './SubjectsDistributionTasksCreate'
import DModal from '../common/DModal'
import StandardDurationSetting from '../School/StandardDurationSetting'
import AppToggle from '../common/AppToggle'
import Loader from '../common/Loader.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import DateSelector from '../datepicker/DateSelector.vue'
import moment from 'moment'
import DoButtonAndDate from '../common/DoButtonAndDate.vue'

const I18N = {
  da: {
    name: 'Navn',
    subjects_for_teachers: 'Fagfordeling',
    filter_users: ' Vælg teams',
    teaching_hours_from_subjects: 'UV-TID FRA FAG',
    created_subject: 'Oprettede faget',
    klass: 'Klasse',
    subjects: 'Fag',
    teaching_hours: 'UV tid',
    no_subjects_assigned: 'Ingen fag tildelt',
    assigned: 'Tildelt',
    from_subjects: 'Fra fag',
    difference: 'Diff',
    only_subjects_without_teachers: 'Vis fag uden underviser',
    only_subjects_with_teachers: 'Vis fag med underviser',
    hours_in_school_year: 'Timer i skoleåret',
    export_to_zen: 'Overfør til automatisk skemalægning',
    go_to_zen: 'Gå til automatisk skemalægning',
    exported_to_zen: 'Data overført til Docendo ZEN',
    something_went_wrong: 'Noget gik galt',
    choose_grades: 'Vælg klasser',
    grades: 'Klasser',
    only_show_users_with_uv_time: 'Vis kun brugere med tildelt UV tid',
    tasks: 'Opgaver',
    no_users_matches: 'Ingen brugere matcher dine filtre',
    print: 'Print opgaveoversigter',
    only_subjects_with_requests: 'Vis kun fag med ønsker',
    subjects_status: 'Status'
  },
  en: {
    subjects_status: 'Status',
    name: 'name',
    subjects_for_teachers: 'Teacher-subject allocation',
    filter_users: ' Filter users by groups',
    teaching_hours_from_subjects: 'Annual instruction time from subjects',
    created_subject: 'Created subject',
    klass: 'Class',
    subjects: 'Subjects',
    teaching_hours: 'Instruction time',
    no_subjects_assigned: 'No subjects allocated',
    assigned: 'Allocated',
    from_subjects: 'From subjects',
    difference: 'Diff',
    only_subjects_without_teachers: 'Show only subjects without teachers',
    only_subjects_with_teachers: 'Show subjects without teachers',
    hours_in_school_year: 'Annual Instruction Time',
    export_to_zen: 'Export to automatic scheduling',
    go_to_zen: 'Go to automatic scheduling',
    exported_to_zen: 'Data is ready in Docendo ZEN',
    something_went_wrong: 'Something went wrong',
    choose_grades: 'Choose grades/groups',
    grades: 'Grades/groups',
    only_show_users_with_uv_time: 'Only show user with assigned teaching hours',
    tasks: 'Tasks',
    no_users_matches: 'No users matches',
    print: 'Print',
    only_subjects_with_requests: 'Show only subjects with requests'
  },
  nb: {
    subjects_status: 'Status',
    name: 'Navn',
    subjects_for_teachers: 'Fag- og lærerfordeling',
    filter_users: ' Filtrer etter gruppe',
    teaching_hours_from_subjects: 'Årstimetall',
    created_subject: 'Opprettet faget',
    klass: 'Klasse',
    subjects: 'Fag',
    teaching_hours: 'Timetall',
    no_subjects_assigned: 'Ingen fag tildelt',
    assigned: 'Tildelt',
    from_subjects: 'Fra fag',
    difference: 'Diff',
    only_subjects_without_teachers: 'Vis kun fag uten underviser',
    only_subjects_with_teachers: 'Vis fag uten underviser',
    hours_in_school_year: 'Timer i skoleåret',
    export_to_zen: 'Overfør for automatisk timeplanlegging',
    go_to_zen: 'Gå til automatisk timeplanlegging',
    exported_to_zen: 'Data is ready in Docendo ZEN',
    something_went_wrong: 'Something went wrong',
    choose_grades: 'Velg klasser',
    grades: 'Klasser',
    only_show_users_with_uv_time: 'Vis kun brukere med tildelt undervisning',
    tasks: 'Oppgaver',
    no_users_matches: 'Ingen brukere passer til søket',
    print: 'Skriv ut',
    only_subjects_with_requests: 'Vis kun fag med ønsker'
  }
}

export default {
  components: {
    DoButtonAndDate,
    DateSelector,
    DoFiltersFilter,
    Loader,
    AppToggle,
    ModalConfirmation,
    ChangeSchoolYear,
    SubjectForm,
    FilterUsers,
    TaggingFilter,
    Spinner,
    SubjectsDistributionTasks,
    AppFlipperButton,
    SubjectsDistributionUser,
    SubjectDistributionPrint,
    SubjectsDistributionTasksCreate,
    DModal,
    StandardDurationSetting
  },
  watch: {
    activeSchoolYear (val) {
      this.readAssignedHours()
      this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
      this.$store.dispatch('readTasks', this.activeSchoolYear.id)
      this.setSubjectsRequestEndDate(this.activeSchoolYear)
      this.readSubjectRequests()
    },
    onlyShowSubjectsWithoutTeacherI18n () {
      if (!this.isShowSubjectsWithoutTeachers) {
        this.selectedSubjectStatusFilters.push(this.onlyShowSubjectsWithoutTeacherI18n)
      }
    }
  },
  data () {
    return {
      subjectSearchQuery: '',
      selectedSubjectStatusFilters: [],
      sortBy: 'name',
      sortOrder: -1,
      isShowOnlyTeacherWithTeachingTime: false,
      isPrintUsers: false,
      editSubject: null,
      theEditTask: null,
      isSubjectModal: false,
      activeUserId: null,
      selectedKlassFilters: [],
      isTasksView: false,
      theZENToken: '',
      isOpenDurationModal: false,
      isModalKlassTotalHours: false,
      subjectsRequestEndDate: null,
      isUpdatingSchoolYear: false,
      isSubjectLoading: false,
      selectedSubjectFilters: []
    }
  },
  computed: {
    subjectStatusFilters () {
      return [this.onlyShowSubjectsWithoutTeacherI18n, this.onlyShowSubjectsWithRequestsI18n, this.onlyShowSubjectsWithTeacherI18n]
    },
    user () {
      return this.$store.state.user
    },
    locale () {
      return this.$store.getters.locale
    },
    school () {
      return this.$store.state.activeSchool
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolCountry () {
      return this.school && this.school.country ? this.school.country : 'NO'
    },
    isSchoolDanish () {
      return this.schoolCountry.toUpperCase() === 'DK'
    },
    isShowSubjectsRequest () {
      return this.isSchoolDanish && this.userHasPermission('can_see_other_subject_requests')
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    userCanManageSchool () {
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions && this.userPermissions.indexOf('can_manage_school') > -1 || (this.user && this.user.admin)
      } else {
        return true
      }
    },
    i18n () {
      return I18N
    },
    zenUrl () {
      let startURL = 'https://zen.docendo.co/login/?jwt='
      if (this.locale === 'da') {
        startURL = 'https://zen.docendo.co/da/login/?jwt='
      }
      if (this.locale === 'nb') {
        startURL = 'https://zen.docendo.co/nb/login/?jwt='
      }

      const schoolUuid = this.school && this.school.uuid ? this.school.uuid : null
      let url = startURL + this.theZENToken
      url += '&domain=' + encodeURIComponent(window.location.hostname)
      if (schoolUuid) {
        url += '&school_uuid=' + schoolUuid
      }

      return url
    },
    isConfirmDeletion () {
      return this.$store.state.subjects.isConfirmDeletion
    },
    itemToDelete () {
      return this.$store.state.subjects.itemToDelete
    },
    klassTags () {
      return this.klassCalendars.map(calendar => calendar.name)
    },
    uniqueSubjects () {
      const names = []
      this.calsWithProps.forEach(klass => {
        klass.vSubjects.forEach(subject => {
          if (subject.name && !names.includes(subject.name)) {
            names.push(subject.name)
          }
        })
      })
      return names
    },
    klassSubjects () {
      const map = {}

      for (const [klassId, subjectIds] of Object.entries(this.subjectsInKlassHash)) {
        map[klassId] = subjectIds.map(subjectId => {
          const subject = this.subjectsInHash[subjectId] || {}

          let calendarHours = null
          if (subject.subject_calendars) {
            const match = subject.subject_calendars.find(sc => sc.calendar_id === parseInt(klassId))
            if (match) {
              calendarHours = parseFloat(match.hours)
            }
          }

          const fallbackHours = parseFloat(subject.hours)
          const vHours = isNaN(calendarHours) ? fallbackHours : calendarHours

          return {
            ...subject,
            vRequestedBy: this.getSubjectedRequestedBy(subjectId),
            vHasTeachers: this.subjectHasTeachers(subjectId),
            vHasRooms: this.subjectHasRooms(subjectId),
            vUserNames: this.getUserNames(subjectId),
            vHours
          }
        })
      }

      return map
    },
    calsWithProps () {
      return this.klassCalendars.map(klass => ({
        ...klass,
        vTotalHours: this.totalHoursCount(klass.id),
        vSubjects: this.klassSubjects[klass.id] || []
      }))
    },
    filteredKlassCals () {
      let klasses = this.calsWithProps

      // Filtrer klasser baseret på valgte klasses
      if (this.selectedKlassFilters.length > 0) {
        klasses = klasses.filter(klass => this.selectedKlassFilters.includes(klass.name))
      }

      const hasStatusFilters = this.selectedSubjectStatusFilters.length > 0
      const hasSubjectFilters = this.selectedSubjectFilters.length > 0

      return klasses.map(klass => ({
        ...klass,
        vSubjects: klass.vSubjects.filter(subject => {
          // Filtrering baseret på statusfiltre
          const hasFilterWithoutTeacher = this.selectedSubjectStatusFilters.includes(this.onlyShowSubjectsWithoutTeacherI18n)
          const hasFilterWithTeacher = this.selectedSubjectStatusFilters.includes(this.onlyShowSubjectsWithTeacherI18n)
          const hasFilterWithRequests = this.selectedSubjectStatusFilters.includes(this.onlyShowSubjectsWithRequestsI18n)

          const matchesStatusFilter = !hasStatusFilters || (
            (hasFilterWithoutTeacher && !subject.vHasTeachers) ||
            (hasFilterWithTeacher && subject.vHasTeachers) ||
            (hasFilterWithRequests && subject.vRequestedBy.length > 0)
          )

          // Filtrering baseret på søgefeltet
          const subjectName = subject.name ? subject.name.toLowerCase() : ''
          const matchesSearch = !this.subjectSearchQuery || subjectName.includes(this.subjectSearchQuery.toLowerCase())

          // Filtrering baseret på valgte fag
          const matchesSubjectFilter = !hasSubjectFilters || this.selectedSubjectFilters.includes(subject.name)

          return matchesStatusFilter && matchesSearch && matchesSubjectFilter
        })
      }))
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isLoading () {
      return this.$store.state.subjects.isLoading
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    usersAssignedHoursHash () {
      return this.$store.getters.usersAssignedHoursHash
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    allUsersInCalendarHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    subjectsInKlassHash () {
      return this.$store.getters.subjectsInKlassHash
    },
    subjectsInUserHash () {
      return this.$store.getters.subjectsInUserHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    tasksInUserHash () {
      return this.$store.getters.tasksInUserHash
    },
    tasksInHash () {
      return this.$store.getters.tasksInHash
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    usersFilteredWithTags () {
      const users = this.$store.getters.usersFilteredWithTags
      if (!this.isPoolsDeactivated && this.isShowOnlyTeacherWithTeachingTime) {
        return users.filter(user => {
          const userHours = this.usersAssignedHoursHash[user.id]
          return userHours && userHours.assigned_teaching_hours
        })
      }
      return users
    },
    sortedUsersFilteredWithTags () {
      if (this.sortBy === 'name') {
        return this.$helpers.sortArrOnName(this.usersFilteredWithTags)
      }
      return this.usersFilteredWithTags.sort((a, b) => this.sortOrder < 0 ? this.getUserTeachingHoursDiff(a.id) - this.getUserTeachingHoursDiff(b.id) : this.getUserTeachingHoursDiff(b.id) - this.getUserTeachingHoursDiff(a.id))
    },
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    isPoolsDeactivated () {
      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false
    },
    doesRessCountInKlassTotalHours () {
      return !this.schoolSettings.hasOwnProperty('hide_ressource_hours_count_in_total_hours_for_klasse')
    },
    subjectsRequestsInHash () {
      return this.$store.getters.subjectsRequestsInHash
    },
    isShowSubjectsWithoutTeachers () {
      return this.selectedSubjectStatusFilters.indexOf(this.onlyShowSubjectsWithoutTeacherI18n) > -1
    },
    isShowSubjectsWithTeachers () {
      return this.selectedSubjectStatusFilters.indexOf(this.onlyShowSubjectsWithTeacherI18n) > -1
    },
    onlyShowSubjectsWithoutTeacherI18n () {
      return this.i18n[this.locale].only_subjects_without_teachers
    },
    onlyShowSubjectsWithRequestsI18n () {
      return this.i18n[this.locale].only_subjects_with_requests
    },
    onlyShowSubjectsWithTeacherI18n () {
      return this.i18n[this.locale].only_subjects_with_teachers
    }
  },
  methods: {
    userHasPermission (permission) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions && this.userPermissions.indexOf(permission) > -1 || this.user.admin
      } else {
        return true
      }
    },
    getSubjectedRequestedBy (subjectId) {
      const currentCalendarIds = this.subjectsRequestsInHash[subjectId] || []
      return currentCalendarIds.filter(calId => calId !== this.userCalendarId && this.allCalendarsInHash[calId]).map(calId => this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId]['name'] : [])
    },
    setSubjectsRequestEndDate (schoolYear) {
      if (schoolYear && Object.prototype.hasOwnProperty.call(schoolYear, 'subject_request_end')) {
        this.subjectsRequestEndDate = schoolYear.subject_request_end
      }
    },
    onSetSubjectsRequestEndDate (date) {
      this.isUpdatingSchoolYear = true
      let dbDate = null
      if (date) {
        dbDate = moment(date).format('YYYY-MM-DD')
      }
      docendo.schoolYearsUpdate(
        this.schoolId,
        this.activeSchoolYear.id,
        {subject_request_end: dbDate},
        success => {
          this.isUpdatingSchoolYear = false
          this.setSubjectsRequestEndDate(success)
          this.updateRORDOMAnnouncementBadge(dbDate)
        },
        failure => {
          console.log('failure', failure)
        }
      )
    },
    updateRORDOMAnnouncementBadge (dbDate) {
      const announcementEl = document.querySelector('.do-top-menu-announcement')
      const navStart = document.querySelector('#nav-start')
      const navEnd = document.querySelector('#nav-end')

      if (!navStart || !navEnd) {
        console.warn('Kunne ikke finde navigationselementerne i headeren.')
        return
      }

      // Hvis dbDate er før i dag, fjern elementet hvis det findes, og stop her
      if (dbDate && moment(dbDate).isBefore(moment(), 'day')) {
        if (announcementEl) {
          announcementEl.remove()
        }
        return
      }

      if (!dbDate) {
        // Hvis dbDate == null og elementet eksisterer → fjern det
        if (announcementEl) {
          announcementEl.remove()
        }
        return
      }

      if (!announcementEl) {
        // Hvis elementet ikke eksisterer, opret det
        const newEl = document.createElement('div')
        newEl.classList.add('do-top-menu-announcement')

        const anchor = document.createElement('a')
        anchor.href = `/schools/${this.schoolId}/subject_requests?school_year_id=${this.activeSchoolYear.id}`
        anchor.innerHTML = `Fagønsker er åben indtil <span data-date="${dbDate}">${moment(dbDate).format('D. MMMM YYYY')}</span>`

        newEl.appendChild(anchor)

        // Indsæt den mellem navStart og navEnd
        navStart.parentNode.insertBefore(newEl, navEnd)
      } else {
        // Hvis elementet eksisterer, opdater <span> med den nye dato
        const spanEl = announcementEl.querySelector('span[data-date]')
        if (spanEl) {
          spanEl.setAttribute('data-date', dbDate)
          spanEl.textContent = moment(dbDate).format('D. MMMM YYYY')
        }
      }
    },
    readSubjectRequests () {
      if (this.isShowSubjectsRequest && this.activeSchoolYear && this.activeSchoolYear.id) {
        this.$store.dispatch('readSubjectRequests', this.activeSchoolYear.id)
      }
    },
    toggleDoesRessCount () {
      if (!this.doesRessCountInKlassTotalHours) {
        this.$store.dispatch('deleteSchoolSetting', 'hide_ressource_hours_count_in_total_hours_for_klasse')
      } else {
        this.$store.dispatch('updateSchoolSettings', {'hide_ressource_hours_count_in_total_hours_for_klasse': true})
      }
    },
    saveUpdatedDuration () {
      this.exportToZen()
    },
    closeIsPrintUsers () {
      this.isPrintUsers = false
      window.scrollTo(0, 0)
    },
    deleteSubject (editSubject) {
      let deletedSubject = {
        id: editSubject.id,
        school_id: editSubject.school_id,
        school_year_id: this.activeSchoolYear.id
      }
      deletedSubject['schoolYearId'] = this.activeSchoolYear.id
      this.$store.dispatch('deleteSubject', deletedSubject)
      this.closeModal()
    },
    exportToZen () {
      docendo.createExport(this.schoolId, this.activeSchoolYear.id, success => {
        eventbus.toast = {text: this.i18n[this.locale].exported_to_zen, 'success': true}
      }, failure => {
        eventbus.toast = {text: this.i18n[this.locale].something_went_wrong, 'success': false}
      })
    },
    userHasAgreements (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].agreements
    },
    setSortBy (key) {
      this.sortBy = key
      this.sortOrder = this.sortOrder * -1
    },
    confirmDelete () {
      if (this.itemToDelete && this.itemToDelete.itemType === 'task') {
        this.$store.dispatch('deleteTask', this.itemToDelete)
        this.$store.commit('setTheDeletedItemId', this.itemToDelete.id)
      }
      this.$store.commit('setConfirmDeletion', false)
      this.$store.commit('setItemToDelete', null)
    },
    subjectHasTeachers (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      let hasTeachers = false
      calIds.forEach(calId => {
        if (this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user') {
          hasTeachers = true
        }
      })
      return hasTeachers
    },
    subjectHasRooms (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      let hasRooms = false
      calIds.forEach(calId => {
        if (this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'room') {
          hasRooms = true
        }
      })
      return hasRooms
    },
    getUserNames (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      if (!calIds || calIds.length < 1 || !calIds[0]) {
        return ''
      }
      return calIds.filter(calId => this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user').map(userCalId => this.allCalendarsInHash[userCalId].name ? this.allCalendarsInHash[userCalId].name : '')
    },
    subjectHasRoom (subjectId) {
      let subject = this.subjectsInHash[subjectId]
      return subject.rooms_calendar_ids && subject.rooms_calendar_ids.length > 0 && subject.rooms_calendar_ids[0]
    },
    updateLocalStorage (key, filters) {
      const val = JSON.stringify(filters)
      this.$helpers.setLocalStorage(key, val)
    },
    toggleFilter (filter, filterArray, storageKey = null) {
      if (filterArray.includes(filter)) {
        filterArray.splice(filterArray.indexOf(filter), 1)
      } else {
        filterArray.push(filter)
      }

      if (storageKey) {
        this.updateLocalStorage(storageKey, filterArray)
      }
    },
    toggleKlassTag (tag) {
      this.toggleFilter(tag, this.selectedKlassFilters, 'doSubjectsDistributionSubjectKlassFilters')
    },
    clearSelectedKlassFilters () {
      this.selectedKlassFilters = []
      const storageKey = 'doSubjectsDistributionSubjectKlassFilters'
      this.updateLocalStorage(storageKey, [])
    },
    toggleSelectedSubjectStatusFilters (filter) {
      this.toggleFilter(filter, this.selectedSubjectStatusFilters, 'doSubjectsDistributionSubjectStatusFilters')
    },
    toggleSelectedSubjectFilters (filter) {
      this.toggleFilter(filter, this.selectedSubjectFilters, 'doSubjectsDistributionSubjectFilters')
    },
    clearSelectedSubjectFilters () {
      this.selectedSubjectFilters = []
      const storageKey = 'doSubjectsDistributionSubjectFilters'
      this.updateLocalStorage(storageKey, [])
    },
    clearSelectedSubjectStatusFilters () {
      this.selectedSubjectStatusFilters = []
      const storageKey = 'doSubjectsDistributionSubjectStatusFilters'
      this.updateLocalStorage(storageKey, [])
    },
    getUserAssignedTeachingHours (userId) {
      return this.usersAssignedHoursHash[userId] ? this.usersAssignedHoursHash[userId].assigned_teaching_hours : 0
    },
    getSubjectHours (subjectId, userCalId) {
      const subject = this.subjectsInHash[subjectId]
      if (!subject) return 0

      // 1. Forsøg at finde timer i brugerens egen kalender
      if (Array.isArray(subject.subject_calendars)) {
        const userMatch = subject.subject_calendars.find(sc =>
          sc.calendar_id === userCalId && sc.hours != null
        )
        if (userMatch) {
          const parsed = parseFloat(userMatch.hours)
          return isNaN(parsed) ? 0 : parsed
        }
      }

      // 2. Hvis ikke, find første klass med timer
      if (Array.isArray(subject.cals)) {
        const klass = subject.cals.find(c => c.calendar_type === 'klass')
        if (klass && Array.isArray(subject.subject_calendars)) {
          const klassMatch = subject.subject_calendars.find(sc =>
            sc.calendar_id === klass.id && sc.hours != null
          )
          if (klassMatch) {
            const parsed = parseFloat(klassMatch.hours)
            return isNaN(parsed) ? 0 : parsed
          }
        }
      }

      // 3. Fallback til subject.hours
      const fallback = parseFloat(subject.hours)
      return isNaN(fallback) ? 0 : fallback
    },
    getTotalSubjectTeachingHours (userCalId) {
      let subjectsHours = [0]
      let subjects = this.subjectsInUserHash[userCalId] ? this.subjectsInUserHash[userCalId].map(subjectId => this.subjectsInHash[subjectId]) : []
      subjects = subjects.filter(subject => {
        let calendarType = this.allCalendarsInHash[subject.calendar_id] ? this.allCalendarsInHash[subject.calendar_id].type : 'null'
        return calendarType === 'klass' || calendarType === 'merge'
      })
      subjectsHours = subjects && subjects.length > 0 ? subjects.map(subject => this.getSubjectHours(subject.id, userCalId) * 1) : [0]
      let total = subjectsHours.reduce((acc, item) => acc + item)
      return total
    },
    getTotalUserTasksTeachingHours (userCalId) {
      const tasks = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].filter(taskId => this.tasksInHash[taskId].subject_type === 'person_resource' || this.tasksInHash[taskId].subject_type === 'person_resource_visible' || this.tasksInHash[taskId].subject_type === 'subject') : null
      const tasksHours = tasks && tasks.length > 0 ? tasks.map(taskId => this.tasksInHash[taskId].hours * 1) : [0]
      return tasksHours.reduce((acc, item) => acc + item)
    },
    getTotalUserHoursTeachingCount (userCalId) {
      return this.getTotalSubjectTeachingHours(userCalId) + this.getTotalUserTasksTeachingHours(userCalId)
    },
    getUserTeachingHoursDiff (userId) {
      const diff = !this.isPoolsDeactivated ? this.getUserAssignedTeachingHours(userId) - this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id) : this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id)
      return diff.toFixed(1)
    },
    setActiveUserId (userId) {
      if (this.activeUserId === userId) {
        return
      }
      this.activeUserId = userId
    },
    resetActiveUserId () {
      setTimeout(_ => {
        this.activeUserId = null
      }, 0)
    },
    getAllUserSubjects (calid) {
      return this.subjectsInUserHash[calid]
    },
    readAssignedHours () {
      let schoolObj = {
        schoolId: this.schoolId,
        schoolYearId: this.activeSchoolYear.id
      }
      this.$store.dispatch('getUsers', this.schoolId, null)
      this.$store.dispatch('readUsersAssignedHours', schoolObj)
    },
    totalHoursCount (klassCalId) {
      let subjectsHours = [0]
      const shouldExcludeTypes = !this.doesRessCountInKlassTotalHours
      const excludedTypes = ['resource', 'person_resource_visible']

      if (this.subjectsInKlassHash[klassCalId]) {
        const subjects = this.subjectsInKlassHash[klassCalId]
          .map(subjectId => this.subjectsInHash[subjectId])
          .filter(subject => !shouldExcludeTypes || excludedTypes.indexOf(subject.subject_type) < 0)

        subjectsHours = subjects.map(subject => {
          let calendarHours = null
          if (subject.subject_calendars) {
            const match = subject.subject_calendars.find(sc => sc.calendar_id === klassCalId)
            if (match) {
              calendarHours = parseFloat(match.hours)
            }
          }

          const fallbackHours = parseFloat(subject.hours)
          const vHours = isNaN(calendarHours) ? fallbackHours : calendarHours
          return isNaN(vHours) ? 0 : vHours
        })
      }

      const sum = subjectsHours.reduce((acc, item) => acc + item, 0)
      return sum.toFixed(2)
    },
    isShowWithoutTeacher (subjectid) {
      if (!this.isShowSubjectsWithoutTeachers) {
        return true
      } else {
        return !this.subjectHasTeachers(subjectid)
      }
    },
    closeModal () {
      this.editSubject = null
      this.isSubjectModal = false
    },
    setEditSubject (editSubject) {
      this.isSubjectLoading = true
      this.isSubjectModal = true
      docendo.showSubject(editSubject.id, success => {
        this.editSubject = Object.assign({}, success)
        this.isSubjectLoading = false
        setTimeout(_ => {
          this.$store.commit('updateSubject', success)
        }, 1500)
        setTimeout(_ => {
          this.isTheCreateCalenderSubjectActive = null
        }, 1)
      }, failure => {
        console.log('failure')
      })
    },
    setEditTask (editTask) {
      this.theEditTask = this.tasksInHash[editTask.id]
    },
    updateSubject (updatedSubject) {
      if (!updatedSubject['schoolId']) {
        updatedSubject['schoolId'] = this.schoolId
      }
      if (!updatedSubject['schoolYearId']) {
        updatedSubject['schoolYearId'] = this.activeSchoolYear.id
      }
      this.$store.dispatch('updateSubject', updatedSubject)
      this.closeModal()
    },
    setPrint () {
      this.isPrintUsers = true
    },
    getZENJWT () {
      docendo.getJwt(data => {
        this.theZENToken = data && data.token ? data.token : ''
      })
    },
    readSubject () {
      this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
    },
    loadFiltersFromLocalStorage (key, filterArray) {
      const deprecatedFilters = ['Vis kun fag uden underviser']
      const storedFilters = this.$helpers.getLocalStorage(key)

      if (storedFilters) {
        let parsedFilters = JSON.parse(storedFilters)

        // Fjern eventuelle forældede filtre
        parsedFilters = parsedFilters.filter(filter => !deprecatedFilters.includes(filter))

        this[filterArray] = parsedFilters

        // Opdater localStorage, hvis der blev fjernet noget
        if (parsedFilters.length !== JSON.parse(storedFilters).length) {
          this.$helpers.setLocalStorage(key, JSON.stringify(parsedFilters))
        }
      }
    }
  },
  beforeMount () {
    if (!this.isShowSubjectsWithoutTeachers) {
      this.selectedSubjectStatusFilters.push(this.onlyShowSubjectsWithoutTeacherI18n)
    }

    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectStatusFilters', 'selectedSubjectStatusFilters')
    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectKlassFilters', 'selectedKlassFilters')
    this.loadFiltersFromLocalStorage('doSubjectsDistributionSubjectFilters', 'selectedSubjectFilters')
  },
  mounted () {
    this.readAssignedHours()
    this.getZENJWT()
    this.readSubjectRequests()
    window.addEventListener('new_subjects_created', () => this.readSubject())
  },
  beforeDestroy () {
    window.removeEventListener('new_subjects_created', () => this.readSubject())
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.subject-dist {
  min-height: 50vh;
}

.subject-dist > .subject-dist__header {
  display: flex;
  justify-content: space-between;
}

.subject-dist > .subject-dist__header h1 {
  margin-right: 10px;
}

.subject-dist__header__right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.subject-dist__header, .doTable__users__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
}

.subject-dist__header__left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.subject-dist__body {
  display: flex;
}

.subject-dist__body > .doTable__users {
  min-width: 300px;
  max-width: 300px;
  margin-right: 1rem;
  overflow: hidden;
}

.subjects-and-tasks {
  width: 100%;
}

.doTable {
  flex: 1;
  border-radius: 4px;
}

ul.doTable__items {
  margin: 0;
}

.doTable__klass {
  margin: 0;
}

.doTable__klass__header {
  display: flex;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: bold;
}

.doTable__klass__header label {
  color: #c0c0c0;
}

.subjects {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-width: 0 1px 0 1px;
  background-color: #ffffff;
}

.subjects_subject {
  position: relative;
  top: 4px;
  left: 2px;
  right: 2px;
  bottom: 0;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 0px 10px 10px 0;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
}

.subjects_subject.subject--has-request:before {
  content: "\e725";
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-room,
.subjects_subject.subject--has-user {
  padding-right: 20px;
}

.subjects_subject.subject--has-room.subject--has-user {
  padding-right: 26px;
}


.subjects_subject.subject--has-room:after {
  content: "\ea38";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-room.subject--has-user:after {
  content: '';
  width: 18px;
  top: 10px;
  height: 18px;
  background-image: url('https://app.docendo.dk/static/img/app/bulk_create_subjects_userlocation.png');
  background-size: 100%;
  background-repeat: no-repeat;
}

.d-box {
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  background: #fff;
  padding: 8px;
  overflow: hidden;
  border-radius: 4px;
}

.d-box.users-list {
  padding: 0;
  background: none;
  box-shadow: none;
}

.user-sorter {
  cursor: pointer;
  transition: transform 0.25s;
  cursor: pointer;
  user-select: none;
  opacity: 0.8;
}

.user-sorter > span {
  opacity: 0.3;
}

.user-sorter:active {
  transform: scale(0.95);
}

.user-sorter.user-sorter--active {
  color: var(--blue);
  opacity: 1;
}

.user-sorter.user-sorter--active > span {
  opacity: 1;
}


.user-item__header.user-item {
  font-weight: bold;
  cursor: default !important;
  background: none;
  box-shadow: none;
  margin-bottom: 0;
  padding: 0 0 4px 0;
  background: transparent;
}

.user-item {
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;
  margin-bottom: 4px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  background-color: #ffffff;
  border-radius: 4px;
}

.user-item .icon-arrow-down4 {
  font-size: 0.8rem;
  margin-left: 0.5rem;
}

.user-item.user-item--is-open {
  background: #fff !important;
  cursor: default;
}

ul.users-list > li.user-item:hover:not(.user-item__header) {
  background-color: #f6f9fc;
}

.user-item__name {
  display: flex;
  align-items: center;
}

.user-item__name__img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 5px;
}

.user-item__name span {
  font-size: 10px;
}

/* EXTRA STYLING */
.flipper-buttons {
  display: flex;
  justify-content: flex-end;
}

.flipper-buttons__button {
  display: flex;
  align-items: center;
  background-color: transparent;
  color: rgba(44, 62, 80, 0.65);
  height: 38px;
  min-width: 130px;
  margin: 0;
  border-radius: 0;
}

.flipper-buttons__button:first-child {
  border-radius: 3px 0 0 3px;
}

.flipper-buttons__button:nth-child(2) {
  border-radius: 0 3px 3px 0;
}

.flipper-buttons__button.active {
  background-color: white;
  color: #2c3e50;
  border: none;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.flipper-buttons__button.active > span {
  color: var(--blue);
}

.flipper-buttons__button span {
  margin-right: 10px;
}

.modal-enter-active, .modal-leave-active {
  transition: all 0.25s;
}

.modal-enter, .modal-leave-to {
  transform: scale(0.75);
  opacity: 0;
}

.explainer-text {
  color: grey;
  font-style: italic;
}

.subject-dist__header__right > label {
  padding-right: 5px;
  user-select: none;
}

.print-label {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

@media print {
  .subject-dist__body {
    display: none;
  }
}

.doTable__klass__header__flex {
  display: flex;
  align-items: center;
}

.label-with-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 4px;
  margin: 0 -0.5rem;
  cursor: pointer;
  transition: 0.15s ease;
}

.label-with-toggle label {
  cursor: pointer;
}

.label-with-toggle:hover {
  background: aliceblue;
}

.d-modal {
  width: 500px;
}

.d-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-modal__content label {
  max-width: 400px;
}

</style>



// WEBPACK FOOTER //
// SubjectsDistribution.vue?f6d4cd30